import gql from 'graphql-tag'

export const DELETE_NOTIFICATION = gql`
  mutation delete_notification($id: ID!) {
    delete_notification(id: $id)
  }
`
